import l from "react";
import { Link as c } from "../../../Link/Link.js";
import { sendClickEvent as p } from "../../utils/sendClickEvent.js";
var s = Object.defineProperty,
  f = Object.defineProperties,
  b = Object.getOwnPropertyDescriptors,
  i = Object.getOwnPropertySymbols,
  y = Object.prototype.hasOwnProperty,
  k = Object.prototype.propertyIsEnumerable,
  m = (t, e, r) => e in t ? s(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[e] = r,
  u = (t, e) => {
    for (var r in e || (e = {})) y.call(e, r) && m(t, r, e[r]);
    if (i) for (var r of i(e)) k.call(e, r) && m(t, r, e[r]);
    return t;
  },
  v = (t, e) => f(t, b(e));
const d = _ref => {
  let {
    children: t
  } = _ref;
  const e = t.links.map((r, n) => r.map((a, o) => v(u({}, a), {
    key: "".concat(o, "-").concat(a.href, "-").concat(n, "-").concat(a.label)
  })));
  return l.createElement(l.Fragment, null, e.map((r, n) => {
    var a;
    return l.createElement("div", {
      className: "olx-seo-footer__tab-column",
      key: ((a = r[n]) == null ? void 0 : a.key) + "column"
    }, r.map(o => l.createElement(c, {
      className: "olx-seo-footer__link",
      href: o.href,
      variant: "grey",
      key: o.href + o.label,
      onClick: () => p("links_tabs", "footer", {
        page_destination: o.href
      }),
      size: "medium",
      "data-ds-component": "DS-Footer-Link"
    }, o.label)));
  }));
};
export { d as ContentLinks };